/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CategorySector {
    App = 1,
    Backend = 2,
    Everywhere = 3,
}
